export default "__VITE_ASSET__BLRNfTal__"